import React from 'react';
import i18n from 'i18next';
import { I18nextProvider } from 'react-i18next';
import translationRU from 'app/locales/ru.json';
import App from './App';

const init = async () => {
  const i18nInstance = i18n.createInstance();
  await i18nInstance.init({
    lng: 'ru',
    debug: false,
    defaultNS: 'translation',
    resources: {
      ru: {
        translation: translationRU,
      },
    },
  });

  return (
    <I18nextProvider i18n={i18nInstance}>
      <App />
    </I18nextProvider>
  );
};

export default init;
